// extracted by mini-css-extract-plugin
export default {"report-icon":"report_report-icon__+NfhB","error_code_strip":"report_error_code_strip__XBku9"};